<script setup>
import Navbar from '@/components/Navbar.vue';
import EventBus from '@/libs/eventBus';
import { onMounted, onUnmounted, ref, onUpdated, watch } from "vue";
import { useRoute, useRouter } from 'vue-router';
import NotificationHeader from "@/components/NotificationHeader.vue";
import api from '@/libs/api.js';
// import Loading from "@/components/Loading.vue";
// import { initializeApp } from "firebase/app";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";

const isAuthenticated = ref(!!localStorage.getItem("token"))
const route = useRoute();
const router = useRouter();
const slotKey = ref(0); // Tạo key động để tái render
watch(isAuthenticated, (newIsAuthenticated, oldIsAuthenticated) => {
   if(newIsAuthenticated && newIsAuthenticated != oldIsAuthenticated){
    // requestFCMToken()
   }
})
// Lắng nghe sự kiện từ EventBus
const handleReloadEvent = () => {
    slotKey.value += 1; // Tăng giá trị key để trigger re-render
};
// const firebaseConfig = {
//     apiKey: "AIzaSyBVkMm_FMtJScFWJsD65g7rxEXQfn0pqLk",
//     authDomain: "vue3-firebase-583db.firebaseapp.com",
//     projectId: "vue3-firebase-583db",
//     storageBucket: "vue3-firebase-583db.firebasestorage.app",
//     messagingSenderId: "819400158463",
//     appId: "1:819400158463:web:08f141aedf5c31892070ca",
//     measurementId: "G-RXGVEJEY6G"
// };
// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const messaging = getMessaging(app);
onMounted(() => {
    EventBus.on("reload-layout", handleReloadEvent); // Lắng nghe sự kiện reload-layout
    EventBus.on('login', () => {
        localStorage.removeItem('token');
        return router.push({ name: 'login' });
    });

})
onUpdated(() =>{
   isAuthenticated.value = !!localStorage.getItem("token")
})
// Bỏ gắn sự kiện khi component bị unmounted
onUnmounted(() => {
    EventBus.off("reload-layout", handleReloadEvent); // Xóa sự kiện để tránh memory leak
    EventBus.on('login', handleReloadEvent);
});
//  const requestFCMToken = async () => {
//       try {
//         const currentToken = await getToken(messaging, {
//           vapidKey: "BEJNsEL2Q-15d3ut2AUwJXMt0YI-zpisYybEjZ3EBIk6xcd3Scm05w8YSrVfJO6a2pROpFUu2xjlGqHVrceQkxM",
//         });

//         if (currentToken) {
//           const response = await api.post("/users/create-fcm-token", {
//             fcm_token: currentToken,
//           });
//           console.log(response);
//         } else {
//           console.log("No registration token available. Request permission to generate one.");
//         }
//       } catch (err) {
//         console.error("An error occurred while retrieving token. ", err);
//       }
//     };
// onMessage(messaging, (payload) => {
//     console.log('Message received. ', payload);
//     // eventBus.emit("message", {message: payload.notification.title, type: 'info'}); // Gọi emit
//      EventBus.emit('show-notification', JSON.stringify({
//             id: '',
//             title: "Thông báo",
//             message: payload.notification.title,
//             url: '',
//             type: 'info',
//             showtime: 2000
//         }));
//     // ...
// });
</script>
<template>
    <div
        class="antialiased w-full h-auto relative bg-gray-50  dark:bg-gray-900 max-w-screen-sm mx-auto overflow-hidden shadow">
        <NotificationHeader ref="notificationHeader" />
        <div class="w-full h-full overflow-auto">
            <router-view></router-view>
        </div>
        <Navbar v-if="route.meta.nav"></Navbar>
        <!-- <Loading v-if="useLayout.loading"></Loading> -->
    </div>
</template>